import React from 'react';
import { ListProvider, StaticFilters } from 'framework/list';
import { useProjectHeatmap } from './useProjectHeatmap';
import ProjectHeatmapBlockHeader from './components/ProjectHeatmapBlockHeader';
import ProjectHeatmapWrapper from './components/ProjectHeatmapWrapper';
import { DashboardItemSectionWrapper } from 'framework/ui/dashboard';

const ProjectHeatmapSection: React.FC = () => {
  const { contextValue, heatmapFilters, getValidationSchema } = useProjectHeatmap();
  const { data } = contextValue;
  const isLoadingLeaves = data?.isLoadingLeaves;

  const title = (
    <ProjectHeatmapBlockHeader title="Project gantt" heatmapFilters={heatmapFilters} loading={isLoadingLeaves} />
  );

  return (
    <ListProvider value={contextValue}>
      <StaticFilters getValidationSchema={getValidationSchema}>
        <DashboardItemSectionWrapper
          key={isLoadingLeaves ? 'loading' : 'ready'}
          defaultExpanded={!isLoadingLeaves}
          isExpandable
          title={title}
        >
          <ProjectHeatmapWrapper />
        </DashboardItemSectionWrapper>
      </StaticFilters>
    </ListProvider>
  );
};

export default ProjectHeatmapSection;
